module.exports = __webpack_public_path__ + "static/media/signUp.66de27a3.svg";